/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectResourceTypeEnum } from './projectResourceTypeEnum';


/**
 * Project resource
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProjectResourceNew { 
    resourceType?: ProjectResourceTypeEnum;
    /**
     * Factor identifier
     */
    identifier?: string;
    /**
     * Resource first name (or group name)
     */
    firstName?: string;
    /**
     * Resource last name
     */
    lastName?: string;
    /**
     * Resource email
     */
    email?: string | null;
    /**
     * Resource organization
     */
    organizationName?: string;
    /**
     * Resource position
     */
    position?: string;
    /**
     * Resource location
     */
    location?: string;
    /**
     * Resource daily rate
     */
    dailyRate?: number | null;
    /**
     * Miradi formatted_text fields (allows limited html markup)
     */
    comments?: string;

    constructor(item?: Partial<ProjectResourceNew>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            resourceType: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.resourceType : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            identifier: {
                
                minLength: 0,
                maxLength: 255,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.identifier : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, 0, 255);
                    }

                    return result;
                }
            },
            firstName: {
                
                
                maxLength: 200,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.firstName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, 200);
                    }

                    return result;
                }
            },
            lastName: {
                
                
                maxLength: 200,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.lastName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, 200);
                    }

                    return result;
                }
            },
            email: {
                type: 'email',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.email : itemOrValue;

                    if (itemOrValue?.email != null) {
                        if (itemOrValue.email === '') {
                            itemOrValue.email = undefined;
                        } else if (['int32', 'int64'].indexOf('email') >= 0) {
                            itemOrValue.email = parseInt(itemOrValue.email.toString(), 10);
                        } else if (['float'].indexOf('email') >= 0) {
                            itemOrValue.email = parseFloat(itemOrValue.email.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'email');
                    if (['uuid'].indexOf('email') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            organizationName: {
                
                
                maxLength: 200,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.organizationName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, 200);
                    }

                    return result;
                }
            },
            position: {
                
                
                maxLength: 200,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.position : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, 200);
                    }

                    return result;
                }
            },
            location: {
                
                
                maxLength: 200,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.location : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, 200);
                    }

                    return result;
                }
            },
            dailyRate: {
                type: 'float',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.dailyRate : itemOrValue;

                    if (itemOrValue?.dailyRate != null) {
                        if (itemOrValue.dailyRate === '') {
                            itemOrValue.dailyRate = undefined;
                        } else if (['int32', 'int64'].indexOf('float') >= 0) {
                            itemOrValue.dailyRate = parseInt(itemOrValue.dailyRate.toString(), 10);
                        } else if (['float'].indexOf('float') >= 0) {
                            itemOrValue.dailyRate = parseFloat(itemOrValue.dailyRate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'float');
                    if (['uuid'].indexOf('float') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            comments: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.comments : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProjectResourceNew.isValid,
        };
    }

    static isValid(obj: ProjectResourceNew): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProjectResourceNew.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.resourceType.isValid(item);
            result = result && validationObject.identifier.isValid(item);
            result = result && validationObject.firstName.isValid(item);
            result = result && validationObject.lastName.isValid(item);
            result = result && validationObject.email.isValid(item);
            result = result && validationObject.organizationName.isValid(item);
            result = result && validationObject.position.isValid(item);
            result = result && validationObject.location.isValid(item);
            result = result && validationObject.dailyRate.isValid(item);
            result = result && validationObject.comments.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

